import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  MobileDetectService,
  ObserverHelper,
  UserModel,
} from '@lib/gc-common';

@Component({
  selector: 'mip-profile-badges',
  templateUrl: './profile-badges.component.html',
  styleUrls: ['./profile-badges.component.scss'],
})
export class ProfileBadgesComponent implements OnInit {
  @Input() profile: UserModel = null;

  isDesktop = false;
  isMobile = false;

  isInteractionsActionsOpened = false;

  autoCloseTimeout = null;
  activeReaction = null;

  observerHelper = new ObserverHelper();

  interactionsActions = [
    { type: 'angry', total: 0 },
    { type: 'crying', total: 0 },
    { type: 'sleeping', total: 0 },
    { type: 'surprised', total: 0 },
    { type: 'laughing', total: 0 },
    { type: 'loved', total: 0 },
    { type: 'happy', total: 0 },
  ];

  reactions = [];

  constructor(private mobileDetectService: MobileDetectService) {
    this.isDesktop = !this.mobileDetectService.isMobile();
    this.isMobile = this.mobileDetectService.isMobile();
  }

  ngOnInit(): void {
    this.reactions = this.interactionsActions.map((action) => ({
      ...action,
      ...this.profile.userStats.reactionsReceivedList.find((reaction) => reaction.type === action.type),
    }));
  }

  toggleChildren() {
    this.isInteractionsActionsOpened = !this.isInteractionsActionsOpened;

    if (this.profile.userStats.reactionsReceivedList) {
      this.autoCloseTimeout = setTimeout(() => {
        this.isInteractionsActionsOpened = false;
      }, 4000);
    }
  }

  toggleReactions() {
    this.isInteractionsActionsOpened = !this.isInteractionsActionsOpened;
  }
}
